import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MenuChangeEvent } from './api/menuchangeevent';

@Injectable({
    providedIn: 'root'
})
export class MenuService {

    private menuSource = new Subject<MenuChangeEvent>();
    private resetSource = new Subject();

    menuSource$ = this.menuSource.asObservable();
    resetSource$ = this.resetSource.asObservable();

    private firstSegmentCounts = new Map<string, number>();

    onMenuStateChange(event: MenuChangeEvent) {
        this.menuSource.next(event);
    }

    reset() {
        this.resetSource.next(true);
    }

    /** ให้ AppMenuComponent เรียกครั้งเดียวหลังสร้างเมนูจาก privilege data ทั้งหมด */
    registerMenuLinks(links: string[]) {
        this.firstSegmentCounts.clear();
        for (const link of links) {
            const segment = link.split('?')[0].split('#')[0].split('/').filter(Boolean)[0];
            if (!segment) continue;
            this.firstSegmentCounts.set(segment, (this.firstSegmentCounts.get(segment) ?? 0) + 1);
        }
    }

    /** true เมื่อไม่มีเมนูอื่นใช้ path segment แรกร่วมกัน (ปลอดภัยที่จะ highlight ทั้งหมวดตาม segment แรก) */
    isFirstSegmentUnique(segment: string): boolean {
        return (this.firstSegmentCounts.get(segment) ?? 0) <= 1;
    }
}
